var _rect, _path, _path2, _rect2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoResults = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 180,
  height: 112,
  fill: "none",
  ref: ref
}, props), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 52.981,
  height: 32.21,
  fill: "#BCCEF5",
  rx: 3,
  transform: "rotate(7.876 58.968 856.537)skewX(.119)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#799DEC",
  d: "M185.293 9.319 112.391 40.66l67.363 9.32 5.539-40.662Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#799DEC",
  d: "m117.932 0 61.243 49.9-66.782-9.239z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.5,
  d: "m178.305 48.97-29.702-24.048 2.618-.871z",
  style: {
    mixBlendMode: "overlay"
  }
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#b)"
}, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 71.458,
  height: 43.443,
  fill: "#BCCEF5",
  rx: 3,
  transform: "matrix(-.99057 .13703 .13497 .99085 70.784 10.282)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#799DEC",
  d: "m-20.074 22.852 98.326 42.273-90.856 12.569z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#799DEC",
  d: "M70.783 10.282-11.82 77.585l90.072-12.46-7.47-54.843Z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.5,
  d: "m-10.647 76.33 40.06-32.434-3.53-1.175-36.53 33.61Z",
  style: {
    mixBlendMode: "overlay"
  }
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E9EFFC",
  d: "M147.75 41.276 88.269 83.108l-59.48-41.832 54.45-38.31a8.76 8.76 0 0 1 5.032-1.593c1.8 0 3.557.556 5.034 1.593l10.861 7.652 2.844 1.99 28.634 20.15 3.017 2.135z"
}))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#BCCEF5",
  d: "m78.597 76.307-49.809 35.692V41.276l49.81 35.03Zm19.346 0 49.81 35.692V41.276z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#799DEC",
  d: "m28.788 112 54.386-38.966a8.74 8.74 0 0 1 5.097-1.642c1.828 0 3.61.574 5.098 1.642L147.75 112z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#F0F8FF",
  d: "M146.729 58.946c11.057 5.213 26.009 8.99 33.271 10.21-1.643 3.85-32.375 32.627-46.151 38.266-.937.146-22.581-10.001-34.46-16.96.404.581 31.291-15.817 47.34-31.516"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#BCCEF5",
  d: "M144.203 67.314a1.99 1.99 0 0 1 1.754-.26l19.332 6.303a1.04 1.04 0 0 1 .481 1.65 1.415 1.415 0 0 1-1.554.435l-19.83-6.844a.729.729 0 0 1-.183-1.284m-5.419 5.19c.491-.465 1.2-.62 1.843-.402l13.38 4.538a.9.9 0 0 1 .409 1.42c-.325.397-.861.55-1.347.383l-14.041-4.818a.67.67 0 0 1-.244-1.12Zm-5.56 4.311a1.88 1.88 0 0 1 1.827-.301l15.415 5.646a.907.907 0 0 1 .352 1.468 1.23 1.23 0 0 1-1.328.313l-16.07-5.943a.69.69 0 0 1-.196-1.183m-12.531 8.623a1.71 1.71 0 0 1 1.891-.454l8.804 3.386c.544.21.742.88.398 1.35-.323.44-.901.608-1.411.41l-9.441-3.686a.63.63 0 0 1-.241-1.006m5.752-4.606a2 2 0 0 1 1.756-.184l20.302 7.48a.92.92 0 0 1 .292 1.55 1.25 1.25 0 0 1-1.262.234l-20.948-7.777a.732.732 0 0 1-.14-1.303"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 52.981,
  height: 32.21,
  fill: "#fff",
  rx: 3,
  transform: "rotate(7.876 58.968 856.537)skewX(.119)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("rect", {
  width: 71.458,
  height: 43.443,
  fill: "#fff",
  rx: 3,
  transform: "matrix(-.99057 .13703 .13497 .99085 70.784 10.282)"
})), /*#__PURE__*/React.createElement("filter", {
  id: "c",
  width: 125.045,
  height: 87.818,
  x: 25.746,
  y: 1.373,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3.042
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.521
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_6701_54882"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_6701_54882",
  result: "shape"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoResults);
export default ForwardRef;